export const SPACE_TYPE_A = "TYPE_A";
export const SPACE_TYPE_B = "TYPE_B";
export const SPACE_TYPE_C = "TYPE_C";
